<template>
  <img
    data-info="base image"
    :src="src"
    :alt="alt"
    :role="role"
    :aria-label="ariaLabel"
    :tabindex="tabindex"
    v-on="$listeners"
    v-bind="$attrs"
  />
</template>

<script>
export default {
  name: "BaseImage",
  inheritAttrs: false,
  props: {
    src: { type: String, required: true },
    alt: { type: String, required: true },
    role: { type: String, required: false },
    ariaLabel: { type: String, required: false },
    tabindex: { type: [String, Number], required: false }
  }
};
</script>
